<template>
  <div class="vue timparty-band-generic band-generic" v-if="band != []" :id="'bnd_' + name_contest">

    <div class="band-generic">
      <div class="row">
        <div class="col-lg-6 p-0" v-if="band.image_position == 'first'">
          <img :src="band.image" alt="" class="w-100">
        </div>
        <div class="col-lg-6 pt-2 pl-4 pd-2 pb-0">
<!--          <div class="half-container p-3 p-md-5">-->
          <div class="half-container p-3 p-md-2">
            <h6 class="section-title mt-1 mb-2" v-html="band.title"></h6>
            <span class="section-content" v-html="band.description"></span>
          </div>
        </div>
        <div class="col-lg-6 p-0" v-if="band.image_position == 'last'">
          <img :src="band.image" alt="" class="w-100">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable */

import TimPartyMixin from '../mixins/TimPartyMixin';

export default {
  name: "BandGeneric",
  mixins: [ TimPartyMixin ],
  data: function(){
    return {
      band: []
    };
  },
  props: {
    name_contest: String
  },
  mounted: function(){
    this.setApiUrl('/api/catalog/handleAction');
    this.getGenericBand();
  },
  methods: {
    getGenericBand: function () {
      var self = this;

      var payload = {
        action: 'getGenericBand',
        contest: this.name_contest
      };

      this.callApi(payload, function (response) {
        self.band = response;
      })
    },
  },
  watch: {
    user: function(new_val){
    }
  },
  computed: {
  },
}

</script>
